import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';

const WaitingCard = () => {
  const navigate = useNavigate();

  return (
    <>
      <Typography
        type='title'
        size='h2'
        className='text-center text-mono-color-darker'
      >
        Estamos gerando o seu cronograma de estudos personalizado!
      </Typography>
      <div className='flex max-w-[660px] flex-col items-center gap-md justify-self-center'>
        <Typography
          weight='bold'
          className='mt-8 text-center  text-mono-color-darker'
        >
          Isso pode levar alguns minutos, pois nosso sistema está processando
          várias solicitações no momento.
        </Typography>
        <Typography className='mt text-center text-mono-color-darker'>
          Continue explorando a plataforma normalmente. Assim que o cronograma
          for concluído, enviaremos uma notificação por e-mail.
        </Typography>
      </div>
      <Typography
        size='h3'
        type='title'
        className='mt-5 text-center text-mono-color-darker'
      >
        Agradecemos pela sua paciência e compreensão.
      </Typography>
      <div className='mt-md flex justify-center mt-8 w-full max-w-[294px] justify-self-center'>
        <Button full onClick={() => navigate('/')}>Voltar ao Aprova Total</Button>
      </div>
    </>
  );
};

export default WaitingCard;
